import order from './order';

class APICall {
    order = order;
}

const API = new APICall();

export default API;
